
import { defineComponent } from "vue";

export default defineComponent({
  name: "UpcomingEvents",
  data() {
    return { 
      events : [],
    }
  },
  mounted() {
    const self = this;
    var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      var response = JSON.parse(this.responseText);
      self.events = response.result.items;
      var out = '';
      var items = response.result.items;
    }
  };
  xhttp.open("GET", "https://tabletop.events/api/convention?query=Protospiel&_include_related_objects=geolocation", true);
  xhttp.send();

  }
});
